import type { Animation } from '@ionic/core';
import { treeNodeOpenAnimation } from './open';

export function treeNodeCloseAnimation(elements: { node: HTMLElement; child: HTMLElement }): Animation {
  return treeNodeOpenAnimation(elements).direction('reverse');
}
